<template>
    <div class="edit-abled f-14 f-c-midgrey f-regular">
        <div class="d-flex-between-center m-d-16" @click="validateAccess('whatsappDevice.update') && gantiNomor()">
            <div>
                <div>
                    <label class="m-d-0">Nomor Whatsapp</label>
                </div>
                <div>
                    <label class="m-d-0  f-16 f-c-black">+{{ dataDevice.country_code }}{{ dataDevice.nomor }}</label>
                </div>
            </div>
            <div v-if="validateAccess('whatsappDevice.update')">
                <IconBased width="20" height="19">
                    <template v-slot:icons>
                        <PencilBlue />
                    </template>
                </IconBased>
            </div>
        </div>
        <div class="separator-line m-d-16"></div>
        <div class="d-flex-between-center m-d-16" @click="validateAccess('whatsappDevice.update') && gantiNama()">
            <div>
                <div>
                    <label class="m-d-0">Nama perangkat</label>
                </div>
                <div>
                    <label class="m-d-0  f-16 f-c-black">{{ dataDevice.nama }}</label>
                </div>
            </div>
            <div v-if="validateAccess('whatsappDevice.update')">
                <IconBased width="20" height="19">
                    <template v-slot:icons>
                        <PencilBlue />
                    </template>
                </IconBased>
            </div>
        </div>
        <div class="separator-line m-d-16"></div>
        <div class="d-flex-between-center m-d-16" @click="validateAccess('whatsappDevice.update') && gantiPaket()">
            <div>
                <div>
                    <label class="m-d-0">Paket</label>
                </div>
                <div>
                    <label class="m-d-0  f-16 f-c-black">{{ dataDevice.nama_paket }}</label>
                </div>
            </div>
            <div v-if="validateAccess('whatsappDevice.update')">
                <IconBased width="20" height="19">
                    <template v-slot:icons>
                        <PencilBlue />
                    </template>
                </IconBased>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import { moduleName } from "../store/state";

import IconBased from "./iconPack/IconBased.vue";
import PencilBlue from "./iconPack/PencilBlue.vue";

export default {
    name: "DeviceEdit",
    props: {
        dataDevice: {
            type: Object,
            required: true,
        },
    },
    components: {
        IconBased,
        PencilBlue,
    },
    methods: {
        ...mapActions({
            setRegistered: `${moduleName}/setRegistered`,
        }),
        gantiNomor() {
            if (this.dataDevice.status === 3) {
                this.$toast.warning("Mohon membeli paket terlebih dahulu, sebelum mengganti nomor!");
            } else if (this.allowEdit()) {
                this.$router.push({ name: "wa_autosender.detail_perangkat.ubah_nomor" });
            }
        },
        gantiNama() {
            if (this.allowEdit()) {
                this.$router.push({ name: "wa_autosender.detail_perangkat.ubah_nama" });
            }
        },
        gantiPaket() {
            if (this.allowEdit()) {
                this.setRegistered({ key: "id_paket", val: "" });
                this.$router.push({ name: "wa_autosender.detail_perangkat.ubah_paket" });
            }
        },
        allowEdit() {
            let allowed = true;
            let expired = this.$moment().isBefore(this.dataDevice.expired_at);
            if (this.dataDevice.status === 2 && expired) {
                this.$toast.error("Lakukan pembayaran paket terlebih dahulu");
                allowed = false;
            }

            return allowed;
        },
    },
};
</script>
<style scoped>
.separator-line {
    margin-left: -20px;
    margin-right: -20px;
}
</style>
